module.exports = __webpack_public_path__ + "img/arrow-left.aaf4ed70.svg";